import type { QueryClient } from '@tanstack/react-query';
import { useAppStore } from '@/store/appStore';
import { useDashboardStore } from '@/store/dashboardStore';

/**
 * Wipes ALL client-side state on logout per CLAUDE.md §3.
 *
 *   1. queryClient.clear() — clear all cached server state
 *   2. zustand store reset() — clear UI state
 *
 * Later prompts add more stores. Each is registered here so logout has a
 * single chokepoint.
 */
export function clearAllClientState(queryClient: QueryClient): void {
  queryClient.clear();
  useAppStore.getState().reset();
  useDashboardStore.getState().reset();
}
